import React from 'react';
import { LngLatBounds } from 'maplibre-gl'; // Importa LngLatBounds
import { MoveHorizontal, MoveVertical } from 'lucide-react';
import useGeoData from '../../store/useGeoData'; // Importa lo store
import './Footer.css';

const Footer: React.FC = () => {
  // Leggi lo stato della mappa dallo store
  const mapState = useGeoData((state) => state.mapState);
  const mapInstance = useGeoData((state) => state.mapInstance);
  const updateMapState = useGeoData.getState().updateMapState;

  // Helper per formattare le coordinate dei bounds
  const formatBounds = (bounds: LngLatBounds | null): string => {
    if (!bounds) return '';
    const sw = bounds.getSouthWest();
    const ne = bounds.getNorthEast();
    return `Bounds: SW(${sw.lng.toFixed(4)}, ${sw.lat.toFixed(4)}) / NE(${ne.lng.toFixed(4)}, ${ne.lat.toFixed(4)})`;
  };

  // Funzione per resettare il bearing a 0
  const resetBearing = () => {
    if (mapInstance) {
      // Anima il bearing a 0 con transizione fluida
      mapInstance.easeTo({
        bearing: 0,
        duration: 500 // 500ms di animazione
      });
    }
    // Aggiorna anche lo stato nello store
    updateMapState({ bearing: 0 });
  };

  // Funzione per resettare il pitch a 0
  const resetPitch = () => {
    if (mapInstance) {
      // Anima il pitch a 0 con transizione fluida
      mapInstance.easeTo({
        pitch: 0,
        duration: 500 // 500ms di animazione
      });
    }
    // Aggiorna anche lo stato nello store
    updateMapState({ pitch: 0 });
  };

  return (
    <footer className="app-footer">
      {/* Contenitore per le informazioni di navigazione */}
      <div className="map-navigation-info">
        <span>Zoom: {mapState.zoom.toFixed(2)}</span>
        <span>Pitch: {mapState.pitch.toFixed(2)}°</span>
        <span>Bearing: {mapState.bearing.toFixed(2)}°</span>
        <span>Center: {mapState.longitude.toFixed(4)}, {mapState.latitude.toFixed(4)}</span>
        {/* Mostra i bounds solo se disponibili */}
        {mapState.bounds && (
          <span style={{ whiteSpace: 'nowrap' }}>
            {formatBounds(mapState.bounds)}
          </span>
        )}
      </div>

      {/* Contenitore per le azioni (eventualmente vuoto o con altri elementi futuri) */}
      <div className="footer-actions">
        {/* Il pulsante Esporta è stato spostato in ProjectActions.tsx */}
        <button 
          className={`bearing-reset-button ${mapState.bearing !== 0 ? 'active' : ''}`}
          onClick={resetBearing}
          disabled={mapState.bearing === 0}
          title="Reset bearing to 0°"
        >
          <MoveHorizontal size={16} />
          <span>Reset Bearing</span>
        </button>
        <button 
          className={`pitch-reset-button ${mapState.pitch !== 0 ? 'active' : ''}`}
          onClick={resetPitch}
          disabled={mapState.pitch === 0}
          title="Reset pitch to 0°"
        >
          <MoveVertical size={16} />
          <span>Reset Pitch</span>
        </button>
      </div>
    </footer>
  );
};

export default Footer;